import { Controller } from "@hotwired/stimulus"
import debounce from "debounce"

export default class extends Controller {
  static targets = ["header", "left", "right"]
  static values = {
    open: { type: String, default: "left" },
    mobileBreakpoint: { type: Number, default: 980 }
  }
  static classes = ["disableTransitions"]

  openStorageKey = "globalOpen"

  nextFrame() {
    return new Promise(resolve => requestAnimationFrame(resolve));
  }

  initialize() {
    // Disabling this bebounce now to prevent nav from flashing on resize
    // this.handleResize = debounce(this.initializeLayout, 50).bind(this)
  }

  connect() {
    console.debug("GlobalController", "Connecting");
    this.initializeLayout();
  }

  reconnect() {
    console.debug("GlobalController", "Reconnecting");
    this.disconnect();
    this.connect();
  }

  async initializeLayout() {
    console.debug("GlobalController", "Initializing layout");

    this.element.classList.add(this.disableTransitionsClass);

    this.setHeaderHeightVariable();
    this.initializeOpen();

    await this.nextFrame();

    this.element.classList.remove(this.disableTransitionsClass);
  }

  handleResize() {
    this.initializeLayout();
  }

  initializeOpen() {
    const isMobile = window.innerWidth < this.mobileBreakpointValue;
    const isRootPage = window.location.pathname === '/';

    if (isMobile || isRootPage) {
      // Always hide nav on mobile or root page
      this.openValue = null;
    } else {
      this.openValue = localStorage.getItem(this.openStorageKey);
    }
  }

  handleBeforeCache() {
    console.debug("GlobalController", "Handling before cache");

    this.element.classList.add(this.disableTransitionsClass);
  }

  setHeaderHeightVariable() {
    const mobileHeaderHeight = this.headerTarget ? this.headerTarget.offsetHeight : 0;
    this.element.style.setProperty('--header-height', `${mobileHeaderHeight}px`);
  }

  toggleLeftOpen() {
    this.openValue = this.openValue === "left" ? null : "left";
    this.storeOpenValue();
  }

  toggleRightOpen() {
    this.openValue = this.openValue === "right" ? null : "right";
    this.storeOpenValue();
  }

  openRight() {
    this.openValue = "right";
    this.storeOpenValue();
  }

  closeRight() {
    this.openValue = null;
    this.storeOpenValue();
  }

  storeOpenValue(value = this.openValue) {
    localStorage.setItem(this.openStorageKey, value);
  }

  openValueChanged() {
    // Toggle inert attribute to control tab order
    this.leftTarget.inert = this.openValue !== "left"
    this.rightTarget.inert = this.openValue !== "right"
  }
}
